import styles from "./styles/Referral.module.css";
import data from "../../../data/multilanguage.json";
import { Fragment, useMemo, useState } from "react";
import { ReactComponent as OkSvg } from "./styles/img/ok.svg";
import { ReactComponent as NotokSvg } from "./styles/img/not_ok.svg";
import { ReactComponent as CopySvg } from "./styles/img/CopySimple.svg";
import parse from "html-react-parser";
import { ReferralTable } from "./referralTable";
import TableFilter from "../Assets/TableFilter";
import { useContext } from "react";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import { submitCaptcha } from "../../../Utils/captcha";
import config from "../../../config";
import { getReferralData } from "../../../Utils/ReferralUtils";
import { Button } from "antd";
import { useAuth } from "../../../Context/AuthContext";
import { useEffect } from "react";
import { UserData } from "../../../Context/DataContext";
import dayjs from "dayjs";
const base_url = config.base_url;
function ReferralContent() {
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.MyAccount.ReferralContent
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );

  const [loading, setLoading] = useState(false);
  const userData = UserData();
  const [referralData, setReferralData] = useState(UserData().referralData);
  const [referralEmail, setReferralEmail] = useState("");
  const [emailInvalid, setEmailInvalid] = useState(false);
  const [invalidEmailFormat, setInvalidEmailFormat] = useState(false);
  const [emailInputTouched, setEmailInputTouched] = useState(false);
  const [showTextCopied, setShowTextCopied] = useState(false);
  const [userAlreadyInvited, setUserAlreadyInvited] = useState(false);
  const [filter, setFilter] = useState();
  const [referral, setReferral] = useState();
  const [ben, setBen] = useState();
  const [timer, setTimer] = useState(undefined);
  //ben here is the reward status, I just do not want to manipulate the original variable names in assetsTable
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.MyAccount.ReferralContent);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  const sortedReferrals = useMemo(() => {
    if (!referralData) return;
    console.log("using memo");
    console.log(referralData);
    let sorted = referralData.referrals.map((referral) => {
      let user_status;
      let reward_status;
      let reward;
      let email_address = referral.customer_email;
      let code = referral.code;
      let method = referral.method;
      let id = referral.id;
      if (referral.reward.time) {
        reward = `${Math.round(referral.reward.time / 2629746000)} ${
          dublicatedcontent.dublicatedText85
        }`;
      }
      if (referral.reward.money) {
        reward = `${referral.reward.money} euros`;
      }
      if (referral.reward.money && referral.reward.time) {
        reward = `${Math.round(referral.reward.time / 2629746000)} ${
          dublicatedcontent.dublicatedText85
        } & ${referral.reward.money} euros`;
      }

      if (referral.status.customer_status === "invitation")
        user_status = dublicatedcontent.dublicatedText86;
      else if (referral.status.customer_status === "trial")
        user_status = dublicatedcontent.dublicatedText87;
      else if (referral.status.customer_status === "subscription")
        user_status = dublicatedcontent.dublicatedText88;
      else if (referral.status.customer_status === "cancelation")
        user_status = dublicatedcontent.dublicatedText89;
      else user_status = dublicatedcontent.dublicatedText86;

      if (referral.reward_status === "done")
        reward_status = `${dublicatedcontent.dublicatedText90}!`;
      else if (referral.reward_status === "none")
        reward_status = dublicatedcontent.dublicatedText91;
      else reward_status = dublicatedcontent.dublicatedText91;

      if (referral.reward_status === "done" && referral.reward?.money) {
        reward_status = `${dublicatedcontent.dublicatedText230}`;
      }
      if (referral.code === "bonus" || referral.code === "BONUS") {
        code = `${dublicatedcontent.dublicatedText231}`;
        email_address = `${dublicatedcontent.dublicatedText231}`;
        method = `${dublicatedcontent.dublicatedText231}`;
        user_status = null;
      }
      return {
        date: dayjs(referral.date).format("YYYY-MM-DD"),
        email_address,
        user_status,
        can_resend: referral.status.can_resend,
        method,
        code,
        reward_status,
        reward,
        id,
      };
    });

    if (referral) {
      sorted = sorted.filter((item) => item.user_status === referral);
    }

    if (ben) {
      sorted = sorted.filter((item) => item.reward_status === ben);
    }

    return sorted;
  }, [
    data,
    referral,
    ben,
    websiteCurrentLang,
    content,
    dublicatedcontent,
    referralData,
  ]);

  const referralTableColumns = [
    {
      Header: content.tableHeader1,
      accessor: "date",
    },
    {
      Header: dublicatedcontent.dublicatedText74,
      accessor: "email_address",
    },
    {
      Header: content.tableHeader3,
      accessor: "user_status",
    },
    {
      Header: content.tableHeader4,
      accessor: "reward",
      disableSortBy: true,
    },
    {
      Header: content.tableHeader5,
      accessor: "reward_status",
      disableSortBy: true,
    },
  ];
  useEffect(() => {
    // This effect will run when the component mounts or when timeoutId changes
    return () => {
      // Cleanup function to clear the timeout when the component unmounts or timeoutId changes
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [timer]);

  const setNewTimeout = () => {
    // Clear the existing timeout if it exists

    if (timer) {
      clearTimeout(timer);
    }

    setTimer(
      setTimeout(() => {
        setEmailInputTouched(false);
        // Your timeout callback function
      }, 3000)
    ); // 5000 milliseconds = 5 seconds
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    if (userData.referralData.ownedCoupons.length === 0) {
      console.log("user does no have a coupon code");
      return;
    }

    setEmailInputTouched(true);
    setEmailInvalid(false);
    setLoading(true);
    setInvalidEmailFormat(false);
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(referralEmail)) {
      setInvalidEmailFormat(true);
      setLoading(false);
      return;
    }
    setEmailInvalid(false);

    const token = await submitCaptcha();
    fetch(base_url + "user/referral/invite", {
      method: "POST",
      mode: "cors",
      body: `email=${referralEmail}&token=${token}&code=${referralData?.ownedCoupons[0]}`,
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
    })
      .then(async (res) => {
        if (res.status === 429) {
          await res
            .json()
            .then((data) => {
              if (data?.ErrorText === "Duplicated") {
                setUserAlreadyInvited(true);
                setTimeout(() => {
                  setUserAlreadyInvited(false);
                }, 3000);
              } else {
                setEmailInvalid(true);
                setLoading(false);
                return;
              }
            })
            .finally(() => {
              throw new Error();
            });
        }
        if (res.status !== 200) throw new Error("An error occurred");
        fetch(base_url + "user/referral/data", {
          method: "POST",
          mode: "cors",
          body: ``,
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-type": "application/x-www-form-urlencoded",
            credentials: "include",
          },
          credentials: "include",
        })
          .then((res) => {
            console.log(res);
            return res.json();
          })
          .then((data) => {
            console.log(Object.is(data, referralData));
            setReferralData({ ...data });
          });
        console.log("No deberñia estar aquí");
        setEmailInvalid(false);
        setLoading(false);
        setInvalidEmailFormat(false);

        setNewTimeout();
      })
      .catch((err) => {
        setEmailInputTouched(false);
        setLoading(false);
        console.log(err);
      });
  };

  return (
    <>
      <div className={styles.section1}>
        {/* first section */}

        <div>
          <p className={styles.section1Title}>
            {content.referralSection1Title}
          </p>
          <p
            style={{
              marginTop: "15px",
            }}
            className={styles.section1Text}
          >
            {content.referralSection1Text}
          </p>
        </div>
      </div>
      <div className={styles.rect} />

      {/* second section */}

      <div className={styles.section2}>
        <p className={styles.section2Title1}>
          {content.referralSection2Title1}
        </p>
        <p className={styles.section2Title2}>
          {content.referralSection2Title2}
        </p>
        <p className={styles.section2Text}>
          {parse(content.referralSection2text)}
        </p>
        <p className={styles.section2Text}>
          {content.referralSection2termsFirstPart}&nbsp;
          <a
            href={`${window?.location?.protocol}//${window?.location?.host}/terms-and-conditions`}
            target="_blank"
            rel="noreferrer"
            className={styles.terms}
          >
            {content.referralSection2termsSecondPart}
          </a>
        </p>
      </div>
      <div className={styles.rect} />

      {/* third section */}

      <div className={styles.section3}>
        {/* TODO: un-comment this section when email translation is ready */}
        <p className={styles.section3Text1}>{content.referralSection3Text1}</p>
        <p className={styles.section3Text2}>{content.referralSection3Text2}</p>
        <form
          id="sendInvite"
          onSubmit={(e) => sendEmail(e)}
          className={styles.section3EmailContainer}
        >
          <input
            placeholder={dublicatedcontent.dublicatedText74}
            className={styles.section3EmailContainerInput}
            onChange={(e) => {
              setReferralEmail(e.target.value.trim());
            }}
            value={referralEmail}
          />
          <Button
            htmlType="submit"
            style={loading ? { width: "85px" } : {}}
            loading={loading}
            className={styles.section3EmailContainerButton}
          >
            {content.referralSection3EmailButtonText}
          </Button>

          {emailInputTouched &&
            !emailInvalid &&
            !loading &&
            !invalidEmailFormat && (
              <div className={styles.section3SuccessMessageContainer}>
                <OkSvg />
                <p>{content.referralSection3EmailSuccess}</p>
              </div>
            )}
        </form>
        {invalidEmailFormat && emailInputTouched && (
          <div className={styles.section3ErrorMessageContainer}>
            <NotokSvg className={styles.section3ErrorMessageContainerSvg} />
            <p className={styles.section3ErrorMessageContainerMessage}>
              {content.referralSection3EmailFailedFormat}
            </p>
          </div>
        )}{" "}
        {emailInvalid && emailInputTouched && (
          <div className={styles.section3ErrorMessageContainer}>
            <NotokSvg className={styles.section3ErrorMessageContainerSvg} />
            <p className={styles.section3ErrorMessageContainerMessage}>
              {content.referralSection3EmailFailed}
            </p>
          </div>
        )}
        {userAlreadyInvited && (
          <div className={styles.section3ErrorMessageContainer}>
            <NotokSvg className={styles.section3ErrorMessageContainerSvg} />
            <p className={styles.section3ErrorMessageContainerMessage}>
              {dublicatedcontent.you_already_invited_this_user}
            </p>
          </div>
        )}
        <p className={styles.section3Text3}>{content.referralSection3Text3}</p>
        <div className={styles.section3ReferralLinkContainer}>
          {[
            ...new Set(referralData?.ownedCoupons?.map((referral) => referral)),
          ].map((code, index) => {
            const referral_url =
              window?.location?.protocol +
              "//" +
              window?.location?.host +
              "/register/?referral=" +
              code;
            return (
              <Fragment key={index}>
                <p className={styles.section3ReferralLink}>{referral_url}</p>
                <CopySvg
                  onClick={(e) => {
                    navigator.clipboard.writeText(referral_url);
                    setShowTextCopied(true);
                    setTimeout(() => {
                      setShowTextCopied(false);
                    }, 3000);
                  }}
                  className={styles.section3ReferralLinkContainerSvg}
                />
              </Fragment>
            );
          })}
        </div>
        {showTextCopied && (
          <div className={styles.section3ReferralLinkTextCopiedContainer}>
            <OkSvg width={20} height={20} />{" "}
            {content.referralSection3ReferralLinkCopiedMessage}
          </div>
        )}
      </div>
      <div className={styles.rect} />

      {/* fourth section */}

      <div className={styles.section4}>
        <p className={styles.section4Text1}>{content.referralSection3Text4}</p>
        <div className={styles.table_div}>
          <TableFilter
            component={"referral"}
            filter={filter}
            setFilter={setFilter}
            setAsset={setReferral}
            setBen={setBen}
          />
          {sortedReferrals && (
            <ReferralTable
              columns={referralTableColumns}
              data={sortedReferrals}
              filter={filter}
              setFilter={setFilter}
              // assetsLength={userData.UserData.assets}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default ReferralContent;
